<template>
  <div>
    <!-- 添加/编辑-题目： -->
    <el-dialog :title="isAdd ? $t('message.addQuestion') : $t('message.editQuestion')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1380px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <!-- 排序 -->
          <el-form-item :label="$t('message.sort')" prop="sort">
            <el-input v-model="ruleForm.sort" style="width: 100px;"></el-input>
            <span style="color: #c35257;">*数字越大越靠前</span>
          </el-form-item>
          <!-- 类目 -->
          <el-form-item :label="$t('message.categoryName')" prop="category_id">
            <el-select v-model="ruleForm.category_id" placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in tableData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 题目 -->
          <el-form-item :label="$t('message.subject')" prop="title">
            <el-input v-model="ruleForm.title" type="textarea"></el-input>
          </el-form-item>
          <!-- 答案 -->
          <el-form-item :label="$t('message.answer')" prop="content">
            <quill-editor ref="myTextEditor" id="quill-editor" v-model="ruleForm.content" :options="quillOption"
              @change="onEditorChange($event)">
            </quill-editor>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="articleAdd" v-if="isAdd">
          {{ $t("message.ok") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="articleEdit" v-else>
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    quillEditor
  },
  props: {
    isAdd: { type: Boolean },
    tableData: { type: Array },
  },
  data() {
    return {
      quillOption: quillConfig,
      ruleForm: {

      },
      dialogVisible: false,
      rules: {
        category_id: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        sort: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ]
      },
    };
  },
  methods: {

    // 新增
    articleAdd() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.siteConfiguration.articleAdd(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.articleList()
          });
        }
      })

    },
    // 修改
    articleEdit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.siteConfiguration.articleEdit(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.articleList()
          });
        }
      })

    },
    acceptData(data) {
      this.ruleForm = data
      this.dialogVisible = true
    },
    onEditorChange(e) {
      console.log(e);
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;


}

/deep/.ql-editor {
  min-height: 300px !important;
}
</style>